import React from 'react';
import { Link } from 'react-router-dom';
import { PageHeader } from '../components/ui/PageHeader';
import { SectionHeading } from '../components/ui/SectionHeading';
import { StepList } from '../components/StepList';
import { CTABand } from '../components/CTABand';
import { Card, CardContent } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { CandidatForm } from '../components/CandidatForm';
import { ShieldCheck, Briefcase, MessageSquare, FileText, Users, Target, Info, PenTool, ArrowDown } from 'lucide-react';
const CANDIDAT_STEPS = [{
  title: 'Premier contact',
  description: 'Remplissez le formulaire de candidature en ligne pour nous faire part de votre projet.',
  icon: <MessageSquare className="w-6 h-6" data-id="element-743" />
}, {
  title: 'Dossier candidat',
  description: 'Transmission de votre CV, lettre de motivation et bulletins scolaires.',
  icon: <FileText className="w-6 h-6" data-id="element-744" />
}, {
  title: "Entretien d'admission",
  description: 'Échange avec notre équipe pour évaluer votre motivation et la cohérence de votre projet.',
  icon: <Users className="w-6 h-6" data-id="element-745" />
}, {
  title: 'Positionnement',
  description: 'Validation de votre profil et de vos prérequis pour la formation visée.',
  icon: <Target className="w-6 h-6" data-id="element-746" />
}, {
  title: 'Information complète',
  description: 'Présentation détaillée du rythme, du programme et des attentes du CFA.',
  icon: <Info className="w-6 h-6" data-id="element-747" />
}, {
  title: "Contrat d'alternance",
  description: "Signature du contrat avec votre entreprise d'accueil et inscription définitive.",
  icon: <PenTool className="w-6 h-6" data-id="element-748" />
}];
export function Candidater() {
  return <div className="flex flex-col w-full" data-id="element-749">
      <PageHeader title="Candidater chez Zillenium" subtitle="Rejoignez notre CFA et donnez un coup d'accélérateur à votre carrière grâce à l'alternance." data-id="element-750" />

      <div className="py-16 md:py-24 bg-muted relative overflow-hidden" data-id="element-751">
        <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary rounded-full blur-[100px] opacity-10 pointer-events-none" data-id="element-752" />
        <div className="container max-w-6xl mx-auto relative z-10" data-id="element-753">
          <div className="text-center mb-20 max-w-3xl mx-auto" data-id="element-754">
            <p className="text-xl md:text-2xl text-primary-dark/80 leading-relaxed font-medium" data-id="element-755">
              Que vous soyez lycéen, étudiant, en reconversion ou parent
              accompagnant un jeune dans son orientation, notre équipe est là
              pour vous guider à chaque étape de votre admission.
            </p>
            <div className="mt-10" data-id="element-756">
              <Button size="lg" className="group bg-brand-orange hover:bg-[#E67E22] text-white text-lg px-10 py-7 shadow-xl" onClick={() => document.getElementById('candidat-form')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-757">
                Remplir le formulaire de candidature
                <ArrowDown className="w-5 h-5 ml-2 group-hover:translate-y-1 transition-transform" data-id="element-758" />
              </Button>
            </div>
          </div>

          <div className="grid lg:grid-cols-5 gap-16 items-start mb-24" data-id="element-759">
            <div className="lg:col-span-3" data-id="element-760">
              <SectionHeading title="Le processus d'admission" className="mb-12" data-id="element-761" />
              <StepList steps={CANDIDAT_STEPS} data-id="element-762" />
            </div>

            <div className="lg:col-span-2 space-y-8 sticky top-8" data-id="element-763">
              <Card className="bg-white border-none shadow-xl hover:-translate-y-2 transition-all duration-300 group" data-id="element-764">
                <div className="h-2 w-full bg-brand-orange" data-id="element-765" />
                <CardContent className="p-8" data-id="element-766">
                  <div className="w-16 h-16 bg-lavande rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-767">
                    <Briefcase className="w-8 h-8 text-brand-orange animate-soft-bounce" data-id="element-768" />
                  </div>
                  <h3 className="font-extrabold font-heading text-2xl text-primary-dark mb-4" data-id="element-769">
                    Aide à la recherche d'entreprise
                  </h3>
                  <p className="text-lg text-muted-foreground leading-relaxed mb-6" data-id="element-770">
                    Une fois votre candidature validée, Zillenium Alternance
                    vous accompagne activement dans votre recherche d'employeur
                    (ateliers CV, préparation aux entretiens, mise en relation
                    avec notre réseau de partenaires).
                  </p>
                  <Button variant="outline" className="w-full border-primary/20 text-primary-dark hover:bg-primary/5 font-semibold" onClick={() => document.getElementById('cap-360-section')?.scrollIntoView({
                  behavior: 'smooth'
                })} data-id="element-771">
                    En savoir plus sur l'accompagnement CAP 360
                  </Button>
                </CardContent>
              </Card>

              <Card className="bg-primary-dark text-white border-none shadow-xl hover:-translate-y-2 transition-all duration-300 group" data-id="element-772">
                <div className="h-2 w-full bg-primary-accent" data-id="element-773" />
                <CardContent className="p-8" data-id="element-774">
                  <div className="w-16 h-16 bg-white/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-775">
                    <ShieldCheck className="w-8 h-8 text-lavande animate-soft-pulse" data-id="element-776" />
                  </div>
                  <h3 className="font-extrabold font-heading text-2xl mb-4" data-id="element-777">
                    Confidentialité
                  </h3>
                  <p className="text-lg text-lavande leading-relaxed" data-id="element-778">
                    Les informations recueillies via notre formulaire sont
                    strictement confidentielles et traitées dans le respect du
                    RGPD, uniquement dans le cadre de votre candidature.
                  </p>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </div>

      {/* CAP 360 Section */}
      <section id="cap-360-section" className="py-24 bg-white relative overflow-hidden scroll-mt-24" data-id="element-779">
        <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-brand-orange rounded-full blur-[100px] opacity-10 pointer-events-none" data-id="element-780" />
        <div className="container max-w-6xl mx-auto relative z-10" data-id="element-781">
          <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-782">
            <div data-id="element-783">
              <SectionHeading title="CAP 360" subtitle="Un accompagnement vers l'alternance, avant l'entrée en formation" className="mb-8" data-id="element-784" />
              <p className="text-lg text-muted-foreground leading-relaxed mb-8" data-id="element-785">
                CAP 360 est un dispositif d'accompagnement mis en place par
                Zillenium Alternance pour aider les futurs apprenants à se
                préparer concrètement à la recherche d'une alternance, avant le
                démarrage des cours. À travers des bootcamps, des ateliers TRE,
                des temps de remise en confiance et un accompagnement
                personnalisé, nous aidons les candidats à lever les freins,
                clarifier leur projet et adopter une posture professionnelle
                adaptée aux attentes des recruteurs.
              </p>

              <div className="bg-muted p-8 rounded-3xl mb-8" data-id="element-786">
                <h4 className="font-bold text-primary-dark mb-4" data-id="element-787">
                  Les futurs apprenants bénéficient notamment de :
                </h4>
                <ul className="space-y-3" data-id="element-788">
                  <li className="flex items-start gap-3" data-id="element-789">
                    <div className="w-2 h-2 rounded-full bg-brand-orange mt-2 shrink-0" data-id="element-790"></div>
                    <span className="text-muted-foreground" data-id="element-791">
                      Ateliers de refonte et d'optimisation des CV
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-792">
                    <div className="w-2 h-2 rounded-full bg-brand-orange mt-2 shrink-0" data-id="element-793"></div>
                    <span className="text-muted-foreground" data-id="element-794">
                      Préparation aux entretiens et simulations en conditions
                      réelles
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-795">
                    <div className="w-2 h-2 rounded-full bg-brand-orange mt-2 shrink-0" data-id="element-796"></div>
                    <span className="text-muted-foreground" data-id="element-797">
                      Travail sur la confiance en soi, l'expression orale et la
                      posture professionnelle
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-798">
                    <div className="w-2 h-2 rounded-full bg-brand-orange mt-2 shrink-0" data-id="element-799"></div>
                    <span className="text-muted-foreground" data-id="element-800">
                      Accompagnement pour dépasser les freins psychologiques
                      liés à la recherche d'emploi
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-801">
                    <div className="w-2 h-2 rounded-full bg-brand-orange mt-2 shrink-0" data-id="element-802"></div>
                    <span className="text-muted-foreground" data-id="element-803">
                      Interventions de professionnels et de partenaires du
                      terrain
                    </span>
                  </li>
                </ul>
              </div>

              <p className="text-lg text-primary-dark font-bold leading-relaxed mb-8" data-id="element-804">
                CAP 360 repose sur un travail commun entre l'étudiant et
                l'équipe Zillenium Alternance. L'objectif n'est pas de faire à
                la place, mais de donner les outils, la méthode et le cadre pour
                permettre à chacun de s'engager efficacement dans sa recherche
                d'alternance.
              </p>
              <Button size="lg" className="group bg-brand-orange hover:bg-[#E67E22] text-white text-lg px-8 py-6 shadow-xl" onClick={() => document.getElementById('candidat-form')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-805">
                Remplir le formulaire de candidature
                <ArrowDown className="w-5 h-5 ml-2 group-hover:translate-y-1 transition-transform" data-id="element-806" />
              </Button>
            </div>

            <div className="grid gap-6" data-id="element-807">
              <Card className="border-none shadow-xl hover:-translate-y-2 transition-transform duration-300 group bg-white" data-id="element-808">
                <div className="h-2 w-full bg-primary" data-id="element-809" />
                <CardContent className="p-8 flex items-center gap-6" data-id="element-810">
                  <div className="w-16 h-16 bg-lavande rounded-2xl flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform duration-300" data-id="element-811">
                    <Target className="w-8 h-8 text-primary animate-soft-bounce" data-id="element-812" />
                  </div>
                  <div data-id="element-813">
                    <h3 className="font-extrabold font-heading text-xl text-primary-dark mb-1" data-id="element-814">
                      CLARIFIER
                    </h3>
                    <p className="text-muted-foreground" data-id="element-815">
                      Définir un projet clair et réaliste
                    </p>
                  </div>
                </CardContent>
              </Card>

              <Card className="border-none shadow-xl hover:-translate-y-2 transition-transform duration-300 group bg-white" data-id="element-816">
                <div className="h-2 w-full bg-brand-orange" data-id="element-817" />
                <CardContent className="p-8 flex items-center gap-6" data-id="element-818">
                  <div className="w-16 h-16 bg-lavande rounded-2xl flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform duration-300" data-id="element-819">
                    <Briefcase className="w-8 h-8 text-brand-orange animate-soft-pulse" data-id="element-820" />
                  </div>
                  <div data-id="element-821">
                    <h3 className="font-extrabold font-heading text-xl text-primary-dark mb-1" data-id="element-822">
                      STRUCTURER
                    </h3>
                    <p className="text-muted-foreground" data-id="element-823">
                      Méthode, outils et cadre pour avancer
                    </p>
                  </div>
                </CardContent>
              </Card>

              <Card className="border-none shadow-xl hover:-translate-y-2 transition-transform duration-300 group bg-white" data-id="element-824">
                <div className="h-2 w-full bg-primary-dark" data-id="element-825" />
                <CardContent className="p-8 flex items-center gap-6" data-id="element-826">
                  <div className="w-16 h-16 bg-lavande rounded-2xl flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform duration-300" data-id="element-827">
                    <Users className="w-8 h-8 text-primary-dark animate-soft-float" data-id="element-828" />
                  </div>
                  <div data-id="element-829">
                    <h3 className="font-extrabold font-heading text-xl text-primary-dark mb-1" data-id="element-830">
                      ACTIVER
                    </h3>
                    <p className="text-muted-foreground" data-id="element-831">
                      Passer à l'action face aux recruteurs
                    </p>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>

      <div id="candidat-form" className="py-24 bg-muted scroll-mt-24" data-id="element-832">
        <div className="container max-w-4xl mx-auto" data-id="element-833">
          <div className="bg-white border-none rounded-3xl p-8 md:p-16 text-center shadow-2xl relative overflow-hidden" data-id="element-834">
            <div className="absolute top-0 right-0 w-64 h-64 bg-brand-orange rounded-full blur-[80px] opacity-10 pointer-events-none" data-id="element-835" />
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-primary rounded-full blur-[80px] opacity-10 pointer-events-none" data-id="element-836" />

            <div className="relative z-10" data-id="element-837">
              <h2 className="text-4xl font-extrabold font-heading text-primary-dark mb-6" data-id="element-838">
                Prêt à vous lancer ?
              </h2>
              <p className="text-xl text-muted-foreground mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-839">
                "Bienvenue ! Ce formulaire rapide nous permet de mieux vous
                connaître et de comprendre votre projet professionnel..."
              </p>
              <div className="mt-8" data-id="element-840">
                <CandidatForm data-id="element-841" />
              </div>
              <div className="mt-12 pt-8 border-t border-slate-100" data-id="element-842">
                <Link to="/entreprises" className="text-base font-medium text-primary hover:text-brand-orange transition-colors underline underline-offset-4" data-id="element-843">
                  Vous êtes une entreprise ? Recruter un alternant
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}